import CustomButton from '../../../common/components/CustomButton';
import CurrencyUtility from '../../../common/utility/CurrencyUtility';

export default function KaraokeOrderFormView1PriceBar({
  planAmount,
  onSubmit,
} : {
  planAmount: number,
  onSubmit: () => void,
}) {
  return (
    <div className="float_link">
      <div className="d-flex">
        <div className="price">
          合計
          <b>{CurrencyUtility.format(((planAmount) * 1.0) / 1.1)}</b>
          円
          <br />
          <span className="small">{`${CurrencyUtility.format(planAmount)}円（税込）`}</span>
        </div>
        <ul>
          <li className="bt">
            <CustomButton type="default" onClick={() => { onSubmit(); }}>次へ</CustomButton>
          </li>
        </ul>
      </div>
    </div>
  );
}
